<template>
    <v-layout row wrap >
    <v-flex xs12 v-if="showFilters">
        <ReportSubscriptionFilter v-on:newReportClicked="$router.push('/subscribe')" v-on:closeDialog="showFilters=!showFilters" v-on:applyFilters="applyFilters"/>   
    </v-flex>
    <v-flex xs12 v-if="!showFilters">
    <v-card flat style="min-height:90vh;overflow-x:scroll;box-shadow: 0px 0px 44px rgba(0, 0, 0, 0.04);border-radius: 10px;">
        <v-card-title class="subheading-title">
                <IconFilter @clicked="showFilters=!showFilters" />
            &nbsp;
            <strong>Quick Preview</strong> 

            <v-spacer/>
        
            <v-icon v-if="selectedReportId" @click="preview" small class="teal--text">fas fa-search</v-icon>
        </v-card-title>
        <hr>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 v-if="Object.keys(selectedSubscription).length>0">
                    <v-chip v-model="filterApplied" @input="resetFilter" close small class="primary white--text">
                        {{selectedSubscription.name}}
                    </v-chip>
                </v-flex>
                <v-flex xs12>
                    <v-select
                    class="style-input"
                    label="Select Report"
                    item-text="name"
                    item-value="id"
                    outline
                    v-model="selectedReportId"
                    :items="reports"
                    v-on:input="setDetails"
                    ></v-select>
                </v-flex>
                <v-flex xs12><v-divider/></v-flex>
                <v-flex xs12 class="text-xs-center" v-show="showReportProgress">
                    <v-progress-circular
                    v-if="showReportProgress"
                    :size="100"
                    :width="15"
                    color="purple"
                    value="Loading"
                    indeterminate
                    ></v-progress-circular>
                </v-flex>
                <v-flex xs12 v-if="!showReportProgress">
                    <v-layout row wrap>
                    <template v-for="filter in filters">
                        <v-flex  xs12 md12>
                            <DropDown :filters="filter"  v-if="filter.type==='select'" 
                            v-on:change="setFilterId"
                            />
                            <TextFilter :filters="filter" v-if="filter.type!='select'" 
                            v-on:change="setFilterId"
                            />
                        </v-flex>
                    </template>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
    </v-flex>
    <v-flex xs12>
    <v-dialog v-model="showReport" fullscreen hide-overlay>
            <ReportViewer :reportData="results" v-if="showReportResults" v-on:closeDialog="closeDialog"/> 
        </v-dialog>
    </v-flex>

    </v-layout>   
</template>
<script>
import IconFilter from '@/components/Icons/IconFilter.vue'
import ReportModel from '@/api/service/ReportService';
import ReportSubscriptionModel from '@/api/service/ReportSubscriptionService'
import DropDown from '@/components/DropDown.vue'
import TextFilter from '@/components/TextFilter.vue'
import ReportViewer from '@/components/ReportViewer.vue'
import ReportSubscriptionFilter from '@/components/ReportSubscriptionFilters.vue'
import moment from 'moment'
export default {
    props: [
    ],
    components: {
        DropDown,TextFilter,ReportViewer,ReportSubscriptionFilter,IconFilter
    },
    data() {
        return {
            report_id:0,
            results:[],
            showFilters:false,
            selectedReportId:0,
            reportName:"",
            reports:[],
            selectedSubscription:{},
            selectedFilters:{},
            selectedReport:{},
            report_description:'',
            filters:[],
            showReport:false,
            showNewReport:false,
            showReportResults:false,
            showReportProgress:false
        }
    },
    created: function() {
        this.getPublishedReport()
    },
    mounted: function () {

    },
    methods: {
        getPublishedReport() {
            ReportModel.getReportForCompany({})
            .then(response => {
                this.setReports(response)                
            }).catch(error => {
                console.log(error)
            }); 
        },

        setReports($data){ 
            this.reports = $data
            this.emailTo = this.$store.getters.userInfo.email
        },
        setDetails() {
        //  alert(selected)
        // alert(this.selectedReportId)
        var $parent = this
            ReportModel.getOne(this.selectedReportId)
                .then(response => {
                    //alert(JSON.stringify(response))
                    $parent.selectedReport = response[0]
                    $parent.report_description = $parent.selectedReport.description
                    $parent.reportName = $parent.selectedReport.name //this.reports[this.report_id].name
                    $parent.report_id = $parent.selectedReport.id
                    //this.setReports(response)     
                    this.setFilters()
                    this.setColumns()           
                }).catch(error => {
                    console.log(error)
            });
        },
        closeDialog() {
            this.showReport=false
            this.showReportResults=false
        },
        closeNewReport() {
            this.showReport=false
            this.showNewReport=false
        },
      setColumns() {
        var $columns = JSON.parse(this.selectedReport.columns)
        var $keys = Object.keys($columns)
        for(var $i=0;$i<$keys.length;$i++) {
           $columns[$keys[$i]].visible=true
           if($columns[$keys[$i]].type=="float"){
             $columns[$keys[$i]].format="0.0"
           }
        }
        this.columns = $columns
      },
      setFilters() {
        this.filters = JSON.parse(this.selectedReport.filters)
        this.setDefaultForFilter() 
       // this.setFilterDefault()
      },
      setFilterId(selected) {
        console.log('i am here')
        //this.selectedFilters.push(selected)
       // console.log($event)
       var $keys = Object.keys(selected);
       this.selectedFilters[$keys[0]]=selected[$keys[0]]
       console.log(this.selectedFilters)
       this.$forceUpdate()
      },
      setFilterIdText(column) {
        console.log(selected)
        console.log(column)
      },
      preview() {
          this.showReportProgress=true
            ReportSubscriptionModel.previewReport({"reportId":this.selectedReportId,filters:this.selectedFilters})
                .then(response => {
                    this.$forceUpdate()
                    this.results= {
                    "name":"Excel Module Test",
                    "headers": response.headers,
                    "data": response.data
                    }
                    this.showReportProgress=false
                    this.showReport=true
                    this.showReportResults=true
                }).catch(error => {
            });   
      },
      applyFilters($subscription) {
          this.selectedSubscription = $subscription
          this.selectedReportId = $subscription.reports.id
          this.setDetails()
          this.showFilters=false
      },
      setDefaultForFilter() {
         var $filter =this.selectedSubscription.filter_options.filter
        var $keys = Object.keys($filter)
        this.selectedFilters={}
        for(var $i=0;$i<$keys.length;$i++) {
            var $key = $keys[$i]
            this.filters[$key].default = $filter[$key]       
            this.selectedFilters[$key]=$filter[$key]
        }
        //this.selectedFilters = $filter
      },
      resetFilter() {
          this.selectedSubscription={}
          var $keys =Object.keys(this.filters)
       
          for(var $i=0;$i<$keys.length;$i++) {
            var $key = $keys[$i]
            this.filters[$key].default = $filter[$key]       
        }
      }
    }
}
</script>
       
     